// Module
var code = "<span class=\"br-body-2 text-ellipsis\"> {{$ctrl.billingAccount.accountingName || $ctrl.billingAccount.id || '---'}} </span> ";
// Exports
export default code;